import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";

type Props = {
    value: number;
    format: (n: number) => string;
    durationMs?: number;
};

/**
 * Animates from 0 to `value` once the component is in view.
 * Uses framer-motion's `animate` for smoothing with no DOM thrash.
 */
export function CountUp({ value, format, durationMs = 1400 }: Props) {
    const [display, setDisplay] = useState(0);
    const ref = useRef<HTMLSpanElement>(null);
    const inView = useInView(ref, { once: true, margin: "-30px" });

    useEffect(() => {
        if (!inView) return;
        const controls = animate(0, value, {
            duration: durationMs / 1000,
            ease: [0.16, 1, 0.3, 1],
            onUpdate: (v) => setDisplay(v),
        });
        return () => controls.stop();
    }, [inView, value, durationMs]);

    return <span ref={ref}>{format(display)}</span>;
}
